import { atom } from "recoil";

export const clearCartState = atom({
    key: "clearCartState",
    default: false,
});